import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import img1 from "./img/news1.svg";
import img2 from "./img/news2.png";
import ShapeMobile6 from "./shapes/ShapeMobile6";

const data = [
	{
		img: img1,
		title: "How to participate in the yLaunch sale?",
		link: "/",
	},
	{
		img: img2,
		title: "How to participate in Yieldly staking?",
		link: "/",
	},
];
const Blog = () => {
	const [mobileScreen, setMobileScreen] = useState(true);

	const handleMobile = () => {
		const width = window.innerWidth;
		if (width < 991) {
			setMobileScreen(true);
		} else {
			setMobileScreen(false);
		}
	};

	useEffect(() => {
		handleMobile();
		window.addEventListener("resize", handleMobile);
	}, []);
	return (
		<section className="blog-section">
			{mobileScreen && (
				<div className="shape-6">
					<ShapeMobile6 />
				</div>
			)}
			<div className="container">
				<h2 className="section-title text-start">Learn More</h2>
				<div className="row g-4 g--4 justify-content-center">
					{data &&
						data.map(({ title, img, link }, i) => (
							<div className="col-xl-4 col-sm-6 mx-xl-4" key={i}>
								<Link to={link} className="post__item">
									<h4 className="subtitle">{title}</h4>
									<img src={img} alt="" />
								</Link>
							</div>
						))}
				</div>
			</div>
		</section>
	);
};

export default Blog;
